/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ShopCouponCreatePage = lazyLoad(
  () => import('./index'),
  module => module.ShopCouponCreatePage
);
